import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-261dc209"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dk-navbar-search dk-navbar__nav-item" }
const _hoisted_2 = ["disabled", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DKIcon = _resolveComponent("DKIcon")!
  const _component_DKSearch = _resolveComponent("DKSearch")!
  const _component_DKSearchArea = _resolveComponent("DKSearchArea")!
  const _component_Megamenu = _resolveComponent("Megamenu")!

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("button", {
      disabled: !!_ctx.isSearchPage,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle'))),
      class: "dk-navbar__search dk-navbar__nav-item-link",
      "aria-label": _ctx.$t('search.input.label')
    }, [
      _createVNode(_component_DKIcon, {
        icon: "search-bold",
        size: 20
      })
    ], 8, _hoisted_2),
    _withDirectives(_createVNode(_component_Megamenu, {
      type: "secondary",
      isTransparent: true,
      isExpanded: true,
      fixHeight: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DKSearchArea, null, {
          default: _withCtx(() => [
            _createVNode(_component_DKSearch, {
              id: "navbar-search",
              type: "secondary",
              searchTerm: _ctx.searchTerm,
              placeholder: 
            _ctx.isDesktop
              ? _ctx.$t('search.input.placeholder')
              : _ctx.$t('search.input.label')
          ,
              onSearch: _ctx.onSearch,
              onRemove: _ctx.onRemove
            }, null, 8, ["searchTerm", "placeholder", "onSearch", "onRemove"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.isExpanded]
    ])
  ]))
}